import { Injectable } from '@angular/core';
import { environment } from "@env/environment";
import { HttpClient } from '@angular/common/http';
@Injectable()
export class companyListService {
  companies:any;
  private ngt18Url: string = environment.API_URL+'main/';
  constructor(private http: HttpClient) {

  }

  clearProjects() {
    this.companies = []
  }

  changeClient(data){
    return this.http.post(this.ngt18Url+'core.instance.changeClient', data);
  }

  getUserRights(loginParam) {
    return this.http.post(this.ngt18Url + 'core.instance.userRights', loginParam);
  }

  getClientDropdown(loginParam) {
    return this.http.post(this.ngt18Url + 'core.instance.dropdownClient', loginParam);
  }
}


